angular.module('invoice')
    .controller('InvoiceRegistrationController', function (item, $location, $rootScope, $state, $stateParams, modals, Client, ClientService, toastr, Invoice, InvoiceService, InvoiceCostType, InvoiceConst) {
        this.InvoiceService = InvoiceService
        this.$onInit = () => {
            this.item = item
            this.itemBefore = angular.copy(item)
            if(this.item.currency == null) {
                this.item.currency = 'PLN'
            }
            this.tabOpened = 0
            InvoiceCostType.autocomplete().$promise.then(items => this.invoiceCostTypes = items)
            Invoice.types().$promise.then(items => {
                this.types = this.item.type != null && !items.includes(this.item.type)
                    ? [this.item.type].concat(items)
                    : items
            })
            this.isAccountantOrManager = InvoiceService.isUserAccountantOrManager()
        }

        this.isConfidentialEnabled = () => {
            return !!this.item?.confidential?.confidential
        }

        this.onConfidentialChanged = () => {
            if (this.isConfidentialEnabled()) {
                delete this.item.confidential
                return
            }
            this.item.confidential = {
                confidential: true,
                accessGroups: []
            }
        }

        this.showConfidentialDisabledHelp = () => {
            return !!this.itemBefore?.confidential?.confidential && !this.isConfidentialEnabled()
        }

        this.addRecipient = (value) => {
            this.item.recipient = value ? {} : null
        }
        this.onIssueDateChanged = value => {
            this.item.dateOfSale = value
        }

        this.save = () => {
            let toSave = angular.copy(this.item)
            let promise
            if (toSave.id != null) {
                promise = Invoice.update(toSave).$promise
            } else {
                promise = Invoice.save(toSave).$promise
            }
            return promise.then(() => {
                $rootScope.$broadcast(InvoiceConst.eventUpdate)
                toastr.success("Zapisano")
                $state.go('invoiceShowFull', {id: toSave.id})
            })
        }

        this.pricingValidated = () => {
            return this.item.pricing != null && InvoiceService.add(this.item.pricing?.totalNet, this.item.pricing?.totalVat) !== this.item.pricing?.totalGross
        }

        this.addClient = (type, nip) => {
            ClientService.addModal({nip: nip})
                .then(result => {
                    let client = {
                        client: {
                            id: result.id,
                            symbol: result.symbol,
                        },
                        fullName: result.fullName,
                        address: result.address,
                        postcode: result.postcode,
                        city: result.city,
                        taxNo: result.nip
                    }

                    switch (type) {
                        case 'seller':
                            this.item.seller = client
                            this.sellerNipNotFound = null
                            break;
                        case 'buyer':
                            this.item.buyer = client
                            this.buyerNipNotFound = null
                            break;
                        case 'recipient':
                            this.item.recipient = client
                            this.recipientNipNotFound = null
                            break;
                        default:
                            break;
                    }
                })
        }

        this.ocr = () => {
            return Invoice.ocr({id: this.item.id}).$promise.then(ocrItem => {
                // this.ocrItem.seller = ocrItem.seller
                // this.ocrItem.buyer = ocrItem.buyer
                this.item.sellerBankAccount = {
                    number: ocrItem.sellerBankAccountNumber?.replaceAll(" ", ""),
                    name: ocrItem.sellerBankAccountName,
                }
                if (ocrItem.sellerNip != null) {
                    Client.autocomplete({q: ocrItem.sellerNip}).$promise.then(items => {
                        if (items.length === 1) {
                            let client = items[0]
                            this.item.seller = {
                                client: {
                                    id: client.id,
                                    symbol: client.symbol,
                                },
                                fullName: client.fullName,
                                address: client.address,
                                postcode: client.postcode,
                                city: client.city,
                                taxNo: client.nip
                            }
                        }
                        if (items.length === 0) {
                            this.sellerNipNotFound = ocrItem.sellerNip
                        }
                    });
                }
                if (ocrItem.buyerNip != null) {
                    Client.autocomplete({q: ocrItem.buyerNip}).$promise.then(items => {
                        if (items.length === 1) {
                            let client = items[0]
                            this.item.buyer = {
                                client: {
                                    id: client.id,
                                    symbol: client.symbol,
                                },
                                fullName: client.fullName,
                                address: client.address,
                                postcode: client.postcode,
                                city: client.city,
                                taxNo: client.nip
                            }
                        }
                        if (items.length === 0) {
                            this.buyerNipNotFound = ocrItem.buyerNip
                        }
                    });
                }
                // this.ocrItem.seller = {
                //     taxNo: ocrItem.sellerNip,
                // }
                // this.ocrItem.buyer = {sellerBankAccount
                //     taxNo: ocrItem.buyerNip,
                // }
                this.item.dateOfIssue = ocrItem.dateOfIssue
                this.item.dateOfSale = ocrItem.dateOfSale
                this.item.number = ocrItem.number
                this.item.pricing = {
                    totalNet: ocrItem.totalNet,
                    totalVat: ocrItem.totalVat,
                    totalGross: ocrItem.totalGross,
                }
                this.item.currency = ocrItem.currency

                if (ocrItem.paidDate != null && ocrItem.paidAmount != null && ocrItem.paidAmount > 0) {
                    this.item.payment = {
                        paidDate: ocrItem.paidDate,
                        paidAmount: ocrItem.paidAmount
                    }
                } else {
                    this.item.payment = {}
                }
                this.item.payment.deadline = ocrItem.paymentDeadline
                this.item.payment.method = ocrItem.paymentMethod
                // this.item.description = ocrItem.description
            })
        }
    })
